var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPedestriancrossingRafiki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-6"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 391.92,
    width: 42.43,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.67,
    y: 389.21,
    width: 78.77,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.89,
    y: 401.21,
    width: 9.89,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.5,
    y: 399.53,
    width: 36.4,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.47,
    y: 399.53,
    width: 13.13,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.33,
    y: 395.31,
    width: 54.56,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.84,124H219.67s-.83-19.63-18.77-25.48c15.29-12.74-18.26-39.6-54.7-2.41,2.84-12.4-29.55-7.92-39.46,9C103.22,94,72.33,113.3,82.84,124Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.42,216.24V230.8a4.06,4.06,0,0,1-4.06,4.06H310.23a4.06,4.06,0,0,0-4.06,4.06v7.46a4.06,4.06,0,0,1-4.06,4.06H268.4a4.06,4.06,0,0,1-4.06-4.06V216.24a4.06,4.06,0,0,0-4.06-4.06H254a4.07,4.07,0,0,1-4.07-4.06v-27a4.06,4.06,0,0,0-4.06-4.06H234.92a4.06,4.06,0,0,0-4.06,4.06v15.08a4.06,4.06,0,0,1-4.06,4.06h0a4.06,4.06,0,0,1-4.06-4.06V144.4a4.06,4.06,0,0,0-4.06-4.06h-11a4.06,4.06,0,0,0-4.06,4.06v51.78a4.06,4.06,0,0,1-4.06,4.06H197a4.06,4.06,0,0,1-4.06-4.06V170.3a4.05,4.05,0,0,0-1.05-2.73l-27.46-30.23a4.1,4.1,0,0,1-1-2.73V116a4.06,4.06,0,0,0-4.06-4.06H130a4.06,4.06,0,0,0-4.06,4.06v80.23a4.06,4.06,0,0,1-4.06,4.06h-3.42a4.06,4.06,0,0,1-4.06-4.06V160.33a4.06,4.06,0,0,0-4.06-4.06H81A4.06,4.06,0,0,0,77,160.33v35.85a4.06,4.06,0,0,1-4.06,4.06H67.68a4.05,4.05,0,0,0-4.06,4.06v3.82a4.06,4.06,0,0,1-4.06,4.06H56.73a4.06,4.06,0,0,0-4.06,4.06v162.1a4.06,4.06,0,0,0,4.06,4.06H339.42a4.06,4.06,0,0,0,4.06-4.06V216.24a4.06,4.06,0,0,0-4.06-4.06H328.48A4.06,4.06,0,0,0,324.42,216.24Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.6,
    cy: 174.98,
    r: 41.36,
    transform: "translate(-34.22 267.34) rotate(-45)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.59,129.92h67.93s15.93-6,13.87-21.89-26.11-2.65-26.11-2.65,7.29-22.17-16-15.88-25.56,28.27-25.56,28.27S341.13,112.43,357.59,129.92Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.07,300h-5.3a4.06,4.06,0,0,1-4.06-4.06v-5.58a4.06,4.06,0,0,0-4.06-4.06h-7.42a4.06,4.06,0,0,1-4.06-4.06V240a4.06,4.06,0,0,0-4.06-4.06H378.74a4.06,4.06,0,0,0-4.06,4.06v42.29a4.06,4.06,0,0,1-4.06,4.06h-5.29a4.06,4.06,0,0,1-4.06-4.06V184.84a4.06,4.06,0,0,0-4.06-4.06H321.84a4.06,4.06,0,0,0-4.06,4.06v26.45a4.06,4.06,0,0,1-1.07,2.75l-32.22,35a4.06,4.06,0,0,0-1.07,2.75v30.48a4.06,4.06,0,0,1-4.06,4.06H275a4.06,4.06,0,0,1-4.06-4.06V261a4.05,4.05,0,0,0-4.06-4.06h-14a4.06,4.06,0,0,0-4.06,4.06v21.23a4.06,4.06,0,0,1-4.06,4.06h-1.32a4.06,4.06,0,0,1-4.06-4.06v-5.74a4.06,4.06,0,0,0-4.06-4.06H221.19a4.06,4.06,0,0,0-4.06,4.06V296a4.06,4.06,0,0,1-4.06,4.06h-8.63a4.05,4.05,0,0,0-4.06,4.06v35.74a4.07,4.07,0,0,1-4.07,4.06h-40.5a4.06,4.06,0,0,1-4.06-4.06v-9.74a4.06,4.06,0,0,0-4.06-4.06H134.6a4.06,4.06,0,0,1-4.06-4.06V304.09a4.06,4.06,0,0,0-4.06-4.06h-14a4.06,4.06,0,0,0-4.06,4.06v38.49a4,4,0,0,1-.76,2.37L85.29,376a4.06,4.06,0,0,0,3.3,6.43H457.21a4.06,4.06,0,0,0,4-4.82l-14.13-74.25A4.05,4.05,0,0,0,443.07,300Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--traffic-lights--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.33,75h0a2.67,2.67,0,0,0-2.66,2.67V398.19H84V77.63A2.67,2.67,0,0,0,81.33,75Z",
    style: {
      fill: "#F15E22"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69.13,
    y: 81.74,
    width: 37.46,
    height: 75.59,
    rx: 3.24
  })), /*#__PURE__*/React.createElement("rect", {
    x: 72.41,
    y: 81.74,
    width: 37.46,
    height: 75.59,
    rx: 3.24,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.14,
    cy: 102.66,
    r: 12.83,
    transform: "translate(-24.79 176.18) rotate(-80.78)",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.14,
    cy: 136.41,
    r: 12.83,
    transform: "translate(-45.27 45.26) rotate(-22.5)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84 157.33 78.67 157.33 78.67 167.24 84 162.69 84 157.33",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pedestrian-crossing--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "270.12 408.58 229.88 408.58 222.46 439.36 277.54 439.36 270.12 408.58",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.12 408.58 229.88 408.58 222.46 439.36 277.54 439.36 270.12 408.58",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.16 408.58 166.92 408.58 136.28 439.36 191.36 439.36 207.16 408.58",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.16 408.58 166.92 408.58 136.28 439.36 191.36 439.36 207.16 408.58",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.21 408.58 103.97 408.58 50.1 439.36 105.18 439.36 144.21 408.58",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.21 408.58 103.97 408.58 50.1 439.36 105.18 439.36 144.21 408.58",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.03 408.58 355.79 408.58 394.82 439.36 449.9 439.36 396.03 408.58",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.03 408.58 355.79 408.58 394.82 439.36 449.9 439.36 396.03 408.58",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.08 408.58 292.84 408.58 308.64 439.36 363.72 439.36 333.08 408.58",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.08 408.58 292.84 408.58 308.64 439.36 363.72 439.36 333.08 408.58",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.36,257.38h0a6.22,6.22,0,0,1-6.2-6.2V242a6.22,6.22,0,0,1,6.2-6.2h0a6.22,6.22,0,0,1,6.2,6.2v9.16A6.22,6.22,0,0,1,165.36,257.38Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.23,192c.11,1.65.14,3.09.14,4.62s0,3-.11,4.52c-.16,3-.45,6-.89,9A73.46,73.46,0,0,1,159.5,219c-.18.74-.43,1.48-.65,2.21s-.45,1.47-.73,2.2-.49,1.42-.81,2.22l-.55,1.25-.63,1.17a29.14,29.14,0,0,1-6.47,7.46,53.42,53.42,0,0,1-7.59,5.26,88.65,88.65,0,0,1-8,4,83,83,0,0,1-8.39,3.11l-1.5-4c2.47-1.23,5-2.56,7.43-4s4.8-2.9,7-4.52a53.82,53.82,0,0,0,6.25-5.17,32.68,32.68,0,0,0,2.59-2.85,20.79,20.79,0,0,0,1.93-3l.36-.76.28-.75c.19-.56.38-1.26.58-1.89s.37-1.29.53-2,.34-1.31.47-2c.59-2.65.95-5.38,1.31-8.1s.53-5.51.62-8.27c.07-1.39.1-2.77.11-4.16s0-2.8-.06-4Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,243.13l-7.36-1.68,2,8.6s4.63-.94,6.73-3.75Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.9 244.68 115.58 250.79 121.6 250.05 119.59 241.45 112.9 244.68",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.26,189c.33,2.71-.39,8.21-1.06,12.35-.49,3-.94,5.26-.94,5.26l-1.69-.23-14-1.89c-1-6.94-1.6-14.64,4.81-20C159.44,181.06,167.67,184.12,168.26,189Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.26,189c.33,2.71-.39,8.21-1.06,12.35-.49,3-.94,5.26-.94,5.26l-1.69-.23-14-1.89c-1-6.94-1.6-14.64,4.81-20C159.44,181.06,167.67,184.12,168.26,189Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.29,189.42c-1-.81-3-.77-7.23,1.11-6.05,2.7-7,9.78-6.57,14.44l10.08,1.36.87.12.82.1s.22-1.13.52-2.86h0c.12-.71.27-1.52.41-2.39C167.83,197.38,168.51,192.25,168.29,189.42Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.88 408.68 178.54 409.48 174.31 390.04 182.66 389.24 186.88 408.68",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.33 389.98 239.65 393.51 229 376.86 236.68 373.33 247.33 389.98",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.36,390.92l8.42-4.39a.68.68,0,0,1,.87.2l4.44,6.16a1.36,1.36,0,0,1-.51,2c-3,1.49-4.47,2-8.17,4-2.28,1.19-7.15,4.16-10.29,5.8s-4.94-1.39-3.78-2.35c5.22-4.33,6.9-7.55,8-10.24A2.21,2.21,0,0,1,237.36,390.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.72,407h10a.85.85,0,0,1,.8.61l2.18,7.94a1.26,1.26,0,0,1-1.23,1.59c-3.53,0-5.21,0-9.62,0H166.4c-3.66,0-4.43-3.7-2.91-4,6.79-1.5,10.71-3.58,12.81-5.56A2.06,2.06,0,0,1,177.72,407Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.32 390.04 176.49 400.06 185.01 400.06 182.66 389.24 174.32 390.04",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.69 373.33 229 376.86 234.49 385.45 242.18 381.92 236.69 373.33",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.71,229.9l-34.05,4.36c-7.69-25.86-10.21-38.34-10.9-44.36a6.54,6.54,0,0,1,4.53-7c2-.64,4.57-1.4,7.13-2,.88-.23,1.76-.44,2.63-.64a109,109,0,0,1,15.47-2c.76-.07,1.53-.11,2.29-.15a104.78,104.78,0,0,1,12.42.2c-.63,6.19-1.08,11.45-1.37,16-.38,6-.5,10.8-.41,15A130.53,130.53,0,0,0,198.71,229.9Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.71,229.9l-34.05,4.36c-7.69-25.86-10.21-38.34-10.9-44.36a6.54,6.54,0,0,1,4.53-7c2-.64,4.57-1.4,7.13-2,.88-.23,1.76-.44,2.63-.64a109,109,0,0,1,15.47-2c.76-.07,1.53-.11,2.29-.15a104.78,104.78,0,0,1,12.42.2c-.63,6.19-1.08,11.45-1.37,16-.38,6-.5,10.8-.41,15A130.53,130.53,0,0,0,198.71,229.9Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.45,209.32c-2.3-5-3.42-15.65-2-19.32l2.38,4.31C196.48,200.29,196.36,205.11,196.45,209.32Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.36,152.26l-13,13.55c-1.08,2,1.51,9.11,10.91,6.7S192,156.33,184.36,152.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.55,140.29c2-10.46,15.45-15.66,23.75-8.15,8.54,7.73-4.16,16.08-3,26.53,1.14,9.81,11.82.87,9.68-2.54,11.15,8.32.78,23.69-15.52,19.41C173.94,169.62,179.47,151,181.55,140.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.91,164.56a7.26,7.26,0,0,1-1.47-.15,6.41,6.41,0,0,1-4.89-5.58c-.74-4.32.74-8.35,2.18-12.26,2-5.52,3.79-10.29-1.35-14.46a.26.26,0,0,1,0-.36.27.27,0,0,1,.37,0c5.43,4.4,3.52,9.57,1.51,15-1.42,3.84-2.88,7.81-2.16,12,.65,3.77,3.09,4.85,4.49,5.16a6.27,6.27,0,0,0,6.32-2.23c1.06-1.54.95-3.46-.31-5.4a.26.26,0,0,1,.07-.36.27.27,0,0,1,.36.08c1.39,2.13,1.5,4.25.31,6A6.61,6.61,0,0,1,209.91,164.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.52,141.19l7.87,7.54c1.15.63,5.28-.88,3.87-6.33S185.87,136.76,183.52,141.19Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.77,167.92c.31,4.21,1.31,8.5,3.75,10.3,0,0-3.12,5.19-11.2,10.86-5.06-3.87-4.27-8.88-4.27-8.88,5.38-2,5-5.73,2.73-11.68l4.2-2.26A2.76,2.76,0,0,1,179.77,167.92Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,166.26a2.74,2.74,0,0,1,4.72,1.28,17,17,0,0,1-7.34,7.51,18.47,18.47,0,0,0-1.58-6.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.3,154.72c-2.09,8.13-2.8,11.61-7.76,15-7.47,5.14-17,.8-17.38-7.78-.35-7.73,3.12-19.73,11.8-21.45A11.44,11.44,0,0,1,186.3,154.72Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.91,143.41c-1.32,3.87,6,11,9.08,11.56-2,1.67-2.48,4.51,0,6.24s12.37-.69,10.52-13.58-20.17-15.37-26.7-5.78C158.81,153.6,173.91,143.41,173.91,143.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.69,162.73a6.11,6.11,0,0,1-3.44,3.18c-2,.72-3.19-1-2.76-3,.39-1.79,1.91-4.33,4-4.2A2.75,2.75,0,0,1,186.69,162.73Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.65,234.27S153,306.14,155.94,325.5c3.73,24.44,17,71.66,17,71.66l14.59-.38s-9.15-54.78-9.34-75.15c-.3-33.78,11.38-90.56,11.38-90.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.05 397.91 188.93 397.45 187.89 391.92 169.6 392.85 172.05 397.91",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.73,250.05,182.37,232l7.22-.93s-5.31,25.83-8.68,53C175.06,276.19,174.47,259.17,176.73,250.05Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.1,233.41s10.34,55.68,19.55,87.48c7.44,25.67,38.65,60.67,38.65,60.67l11-5.54s-21-38.77-26.14-56.21c-16.6-55.82-3.62-76.11-16.48-89.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.38 384.96 243.37 378.25 241.42 372.71 227.07 380.67 230.38 384.96",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,227.84l1.92,2.85c.15.22-.1.5-.49.55l-35.72,4.58c-.31,0-.58-.08-.62-.27l-.7-3c-.05-.21.19-.42.53-.47l34.49-4.42A.62.62,0,0,1,199,227.84Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,227.84l1.92,2.85c.15.22-.1.5-.49.55l-35.72,4.58c-.31,0-.58-.08-.62-.27l-.7-3c-.05-.21.19-.42.53-.47l34.49-4.42A.62.62,0,0,1,199,227.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.83,232.29l.92-.12c.19,0,.31-.14.29-.25L195.1,228c0-.11-.21-.19-.39-.16l-.92.12c-.19,0-.31.13-.29.25l.94,3.9C194.47,232.24,194.64,232.31,194.83,232.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.32,235.81l.92-.11c.19,0,.31-.14.29-.26l-.94-3.9c0-.11-.2-.19-.39-.17l-.92.12c-.19,0-.31.14-.29.25l.94,3.91C167,235.76,167.13,235.84,167.32,235.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.07,234.05l.93-.12c.18,0,.31-.13.28-.25l-.94-3.9c0-.12-.2-.19-.38-.17l-.93.12c-.18,0-.31.14-.28.25l.94,3.91C180.72,234,180.89,234.07,181.07,234.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.38,154.37c-.13.67-.59,1.15-1,1.06s-.69-.69-.56-1.36.59-1.15,1-1.06S172.51,153.7,172.38,154.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.81,152.92c-.13.67-.59,1.14-1,1.06s-.69-.7-.56-1.37.59-1.14,1-1.06S164.94,152.25,164.81,152.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.44,151.63l-1.52-.78S163.5,152.27,164.44,151.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.81,154.42a18.19,18.19,0,0,1-3.21,3.81,2.91,2.91,0,0,0,2.3.91Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.46,162.48a.19.19,0,0,1-.08-.2.2.2,0,0,1,.23-.16,5.4,5.4,0,0,0,4.72-1.24.22.22,0,0,1,.29,0,.21.21,0,0,1,0,.29,5.71,5.71,0,0,1-5.09,1.35A.11.11,0,0,1,168.46,162.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,152.31a.44.44,0,0,1-.14-.16,3.16,3.16,0,0,0-2.26-1.79.4.4,0,0,1-.35-.45.39.39,0,0,1,.44-.35,4,4,0,0,1,2.89,2.24.4.4,0,0,1-.18.54A.41.41,0,0,1,175,152.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.16,149s0,0,0-.07a.4.4,0,0,1,.27-.5,4,4,0,0,1,3.6.6.4.4,0,1,1-.51.61,3.21,3.21,0,0,0-2.86-.44A.39.39,0,0,1,162.16,149Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.3,184.1c1.12,1.21,2,2.31,3,3.51s1.87,2.37,2.76,3.58q2.64,3.66,5,7.57a71.32,71.32,0,0,1,4.16,8.12c.33.69.59,1.42.88,2.13s.58,1.42.82,2.16.51,1.42.76,2.24l.36,1.32.25,1.31a29.4,29.4,0,0,1-.35,9.87,52.94,52.94,0,0,1-2.6,8.85A87.84,87.84,0,0,1,211.6,243a82.41,82.41,0,0,1-4.58,7.69l-3.69-2.17c1.16-2.51,2.3-5.15,3.28-7.77s1.91-5.28,2.64-7.95a51.93,51.93,0,0,0,1.62-7.95,31.46,31.46,0,0,0,.22-3.84,21,21,0,0,0-.38-3.55l-.2-.81-.25-.77c-.2-.55-.49-1.22-.73-1.83s-.53-1.24-.82-1.85-.55-1.23-.87-1.84c-1.21-2.43-2.64-4.78-4.07-7.13s-3.05-4.61-4.72-6.82q-1.23-1.68-2.52-3.3c-.86-1.05-1.78-2.17-2.59-3.11Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,246.06l-6.78,3.32,7,5.44s3-3.64,2.89-7.15Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.04 256.1 200.96 259.17 205.18 254.82 198.22 249.38 195.04 256.1",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.23,178.27c4.22.57,10.59,12.34,10.59,12.34l-8.45,11s-10.5-9.81-10.28-15.28C190.28,181.66,192.85,177.54,198.23,178.27Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.23,178.27c4.22.57,10.59,12.34,10.59,12.34l-8.45,11s-10.5-9.81-10.28-15.28C190.28,181.66,192.85,177.54,198.23,178.27Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234,394l-.13,0a1.16,1.16,0,0,1-.79-.79.72.72,0,0,1,.09-.69c.67-.85,3.71-.56,4.06-.53a.2.2,0,0,1,.11.35C236.5,393,235,394.1,234,394Zm2.7-1.67c-1.22-.08-2.86,0-3.21.42a.29.29,0,0,0,0,.3.74.74,0,0,0,.51.54C234.51,393.69,235.52,393.22,236.68,392.28Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,392.3c-1-.15-2.93-1-3.18-1.85a.69.69,0,0,1,.34-.81,1,1,0,0,1,.87-.15c1.19.29,2.33,2.45,2.38,2.54a.2.2,0,0,1,0,.2.21.21,0,0,1-.18.09Zm-2.15-2.44a.62.62,0,0,0-.47.11c-.21.15-.21.27-.18.37.17.56,1.65,1.34,2.66,1.53-.42-.69-1.22-1.82-1.93-2Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.27,408.61a3.3,3.3,0,0,1-2-.47,1.22,1.22,0,0,1-.51-1,.57.57,0,0,1,.25-.55c.91-.61,4.32.94,5,1.25a.2.2,0,0,1,0,.38A13.54,13.54,0,0,1,173.27,408.61Zm-1.59-1.73a.75.75,0,0,0-.4.08.19.19,0,0,0-.07.19.83.83,0,0,0,.35.67c.59.45,2,.5,3.77.17A12.71,12.71,0,0,0,171.68,406.88Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,408.26h-.07c-1.13-.46-3.42-2.29-3.29-3.24,0-.21.17-.47.69-.53,2-.23,2.83,3.39,2.87,3.54a.2.2,0,0,1-.07.2A.18.18,0,0,1,176,408.26Zm-2.49-3.39h-.13c-.21,0-.33.09-.34.18-.08.55,1.5,2,2.66,2.63C175.4,406.82,174.68,404.87,173.48,404.87Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,153.08l-1.51-.77S171.07,153.72,172,153.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.92,240.21a.52.52,0,0,1-.52-.52c-.26-28.75,27-61.73,27.29-62.06a.51.51,0,0,1,.73-.06.52.52,0,0,1,.07.73c-.28.33-27.3,33-27.05,61.38a.53.53,0,0,1-.52.53Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.33,167.73c.87-4.76,2.62-9.66-1.95-11.89s-25.48-5.79-32-3.18-.46,15.43,4.21,19.86S339.23,179.18,341.33,167.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.97 416.6 375.92 414.75 372.78 395.64 364.84 397.49 367.97 416.6",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.86 418.9 312.05 419.74 314.99 400.79 306.8 399.95 303.86 418.9",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.94,418.51l-10-.85a.72.72,0,0,0-.75.5l-2.25,7.17a1.21,1.21,0,0,0,1.08,1.56c3.23.22,5.6.23,9.66.58,2.5.21,6.29,1.6,12.7,1.6,3.38,0,3-3.48,1.59-3.7-7.07-1.07-8.85-4.24-10.72-6.24A2,2,0,0,0,312.94,418.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.51,413.17l-8.75,2.14a.72.72,0,0,0-.55.72l.16,7.51a1.21,1.21,0,0,0,1.51,1.14c3.14-.83,7.65-2.13,11.62-3.1,4.64-1.14,5.47-1.05,10.91-2.38,3.29-.81,3.39-4.36,1.94-4.32-6.61.17-8.52.45-14.76-1.56A3.79,3.79,0,0,0,375.51,413.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.73,161.78c2.36,5,4.79,10.16,7.24,15.16,1.24,2.5,2.45,5,3.74,7.44s2.55,4.84,3.9,7.06c.67,1.12,1.34,2.17,2,3.14a14.06,14.06,0,0,0,4,4.2c1,.76,2.1,1.49,3.21,2.27,4.49,3,9.38,6.11,14.06,9.42l-3.14,7.63A93.19,93.19,0,0,1,365.54,213c-1.43-.58-2.84-1.22-4.32-2a28.61,28.61,0,0,1-4.7-2.86,29.18,29.18,0,0,1-4.13-4.22c-1.09-1.32-2.07-2.62-3-3.92a149.91,149.91,0,0,1-9.3-15.56c-2.77-5.26-5.29-10.47-7.63-16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.74,210.87l3.72,1-1.8,9.4a30.83,30.83,0,0,1-5.32-3.72,3.78,3.78,0,0,1-1.07-3.93l.11-.37A3.58,3.58,0,0,1,385.74,210.87Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.11 216.4 390.73 223 387.66 221.28 389.46 211.88 396.11 216.4",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.78 395.64 374.4 405.49 366.45 407.35 364.83 397.5 372.78 395.64",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.8 399.95 314.99 400.8 313.47 410.56 305.28 409.72 306.8 399.95",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.41,160.12a8.55,8.55,0,0,0-6.77,10.34c1.4,6.37,2.42,12.72,3.16,18.8.78,6.39,1.25,12.49,1.54,18,.69,13,.4,22.86.79,26.2l44-3.06c4.48-35.07-.78-57.44-3.72-66.5a7.79,7.79,0,0,0-6.38-5.34c-1.7-.22-3.74-.44-5.88-.56q-1.12-.08-2.28-.09a161.71,161.71,0,0,0-18.71,1.3c-1.18.14-2.37.31-3.53.5C311.88,159.85,311.13,160,310.41,160.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,224c7.14-6.14,9.51-15.83,9.51-15.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.83,222c-5.18-5.82-4.58-14.6-4.58-14.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.39,178.49c0,7.38-2,12.37-6.16,14.58-.13-1.26-.27-2.53-.43-3.81-.58-4.8-1.34-9.77-2.35-14.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.55,138c1.6,5.94,3.55,16.89-.38,21.2,5.24,2.75,16.7,4.7,16.7,4.7s3.85-4.08,2-6c-6.82-1.13-7-6.12-6.16-10.88Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.52,141.71l7.2,5.32a20.61,20.61,0,0,0-.35,3.36c-2.59-.19-6.31-2.76-6.77-5.42A8.86,8.86,0,0,1,321.52,141.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.07,134c1.68-8.47-.33-12.42,2.19-17.4,1.71-1.43,6.17,1.2,5.65,8S330.07,134,330.07,134Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.21,129c1.07,8.12,1.28,12.92,5.69,16.82,6.63,5.86,16.43,1.43,17.81-6.85,1.24-7.44-.72-19.47-8.92-22.15A11.16,11.16,0,0,0,315.21,129Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.71,135.55l5.43,1.43-1.56-7.67,3.18-3.26.29-5.46s-10.89-.06-14,.4-1.48,8.55-1.48,8.55A22.41,22.41,0,0,0,316.71,135.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.29,123.63l4.16-3.87s4.75-1.86,8.52.83c2.7,1.6,3.56.45,3-3.44-.49-3.27-3.3-7.31-9.44-4.58-3.84,1.71-12.39-1-16,1s-5.67,8.41.48,9.76S322.29,123.63,322.29,123.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.35,120.2c6-.61,8.82.78,9.25,2.55,1.09-.56.7-3.37-2.86-4.54S323.35,120.2,323.35,120.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.16,112.26c-.13,6.07,1.48,8.73,3.28,9-.47,1.12-3.3,1-4.75-2.49S308.16,112.26,308.16,112.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,139.4h0a6,6,0,0,1-5.12-2.09.21.21,0,0,1,.33-.25A5.7,5.7,0,0,0,331,139a.21.21,0,0,1,.22.2A.2.2,0,0,1,331,139.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.32,137a7.81,7.81,0,0,0,4.52,3.87c2.6.83,4-1.47,3.35-4-.57-2.25-2.62-5.4-5.27-5.14S311.2,134.75,312.32,137Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.17,402.26l-13.56,3.32s-11.05-48.82-15.2-78c-1.1-7.74-4.65-18.45-7.24-30.06-3.27-14.61-7.37-30.42-10.72-42.8-3.54-13-6.24-22.26-6.24-22.26l28.94-2s15.65,68.29,17.32,93.41C372.19,350,377.17,402.26,377.17,402.26Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.17,297.5c-3.27-14.61-7.37-30.42-10.72-42.8l3-6.47C340.63,256.76,342.56,283.16,341.17,297.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.54,231.51s-2.68,71-6.16,94.95c-3.81,26.19-13.47,82.24-13.47,82.24l-15.05-1.29s2.87-52.05,6.16-77.58c3.75-29.16.11-96.34.11-96.34Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.15 409.13 301.96 407.67 302.41 402.37 321.08 402.37 319.15 409.13",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.1 402.37 362.79 406.12 360.75 400.82 378.21 396.51 378.1 402.37",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.73,130.44c0,.66.43,1.17.87,1.14s.75-.59.7-1.25-.44-1.18-.87-1.15S327.68,129.77,327.73,130.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.23,129.91c0,.67.44,1.18.87,1.15s.75-.59.7-1.26-.43-1.17-.87-1.14S335.19,129.25,335.23,129.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.87,130.41a24.06,24.06,0,0,0,3.57,5.46c-1.1,1.17-3.23.65-3.23.65Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.23,128.17a.37.37,0,0,0,.37-.17,3.12,3.12,0,0,1,2.41-1.48.39.39,0,1,0,0-.78,3.87,3.87,0,0,0-3.06,1.83.39.39,0,0,0,.11.54A.27.27,0,0,0,325.23,128.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.27,127.11a.37.37,0,0,0,.23,0,.4.4,0,0,0,.15-.54,3.88,3.88,0,0,0-3-2,.4.4,0,0,0-.41.37.39.39,0,0,0,.37.41h0a3.1,3.1,0,0,1,2.32,1.61A.41.41,0,0,0,338.27,127.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.53,420.18a2.46,2.46,0,0,0,1.62-.28,1.17,1.17,0,0,0,.49-1,.62.62,0,0,0-.29-.58c-.87-.54-3.66.86-4,1a.21.21,0,0,0-.11.19.19.19,0,0,0,.14.17A9.09,9.09,0,0,0,315.53,420.18Zm1.37-1.6a.61.61,0,0,1,.25.08c.05,0,.1.08.1.23a.79.79,0,0,1-.33.69c-.48.34-1.55.3-2.93-.1A8,8,0,0,1,316.9,418.58Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.45,419.71a.17.17,0,0,0,.1,0c.89-.39,2.68-2.05,2.59-3a.65.65,0,0,0-.58-.57,1.1,1.1,0,0,0-.85.18c-1,.7-1.42,3.06-1.43,3.16a.16.16,0,0,0,.07.18A.13.13,0,0,0,313.45,419.71Zm1.94-3.19.09,0c.25,0,.26.17.27.22.06.55-1.11,1.82-2,2.39a4.72,4.72,0,0,1,1.19-2.49A.68.68,0,0,1,315.39,416.52Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.56,414.08h0c1.35-.06,3.72-.3,4.41-1.3a1.08,1.08,0,0,0,.13-1,.59.59,0,0,0-.44-.42c-1.09-.29-3.92,2.11-4.24,2.39a.2.2,0,0,0,0,.22A.17.17,0,0,0,376.56,414.08Zm4-2.37h.05a.24.24,0,0,1,.17.18.69.69,0,0,1-.08.66c-.39.56-1.69,1-3.53,1.1C378.3,412.73,379.9,411.62,380.55,411.71Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.56,414.08a.17.17,0,0,0,.15,0c.86-.67,2.35-2.87,2-3.74-.09-.2-.3-.43-.84-.36a1.44,1.44,0,0,0-1,.59c-.81,1.08-.5,3.29-.49,3.39a.2.2,0,0,0,.12.15Zm1.57-3.76c.16,0,.19.1.2.13.22.52-.75,2.2-1.59,3a4.62,4.62,0,0,1,.45-2.73,1,1,0,0,1,.72-.43Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,232.16l5.58,6.25-10.07,3.1s-3.57-6.37-.41-8.64Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.04 245.28 298.59 247.46 296.47 241.51 306.54 238.41 307.04 245.28",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.31,173.67,315.79,177l-2.55,3.46c-1.69,2.32-3.33,4.67-4.91,7a93.78,93.78,0,0,0-8.08,14.2c-1.62,2.22-1.06,8.37-.46,13.94s1.63,11.61,2.47,17.46l-7.82,2.62c-1.47-2.84-2.71-5.64-3.89-8.54s-2.23-5.85-3.18-8.9a68.22,68.22,0,0,1-2.25-9.63,31.69,31.69,0,0,1-.41-5.65,18.29,18.29,0,0,1,.44-3.61c.18-.8.29-1.11.41-1.55s.24-.87.38-1.28a66.92,66.92,0,0,1,3.79-9.39c1.41-3,3-5.78,4.64-8.52s3.39-5.39,5.23-8c.91-1.29,1.84-2.57,2.81-3.82s1.92-2.45,3.06-3.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.37,165.44a3.39,3.39,0,0,0,0,.34,5,5,0,0,0,0,.55c0,.39.06.78.11,1.18l.29,2.41c.21,1.62.4,3.26.51,4.91a36.66,36.66,0,0,1,0,5,18.42,18.42,0,0,1-1,5.14l-2.62-1.08a16.22,16.22,0,0,0,1.25-4.33,34.79,34.79,0,0,0,.39-4.71c0-1.6,0-3.21-.05-4.84l-.08-2.45c0-.41,0-.83,0-1.26q0-.32.06-.66a1.88,1.88,0,0,1,.27-.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.47,163.05a21.23,21.23,0,0,1,2.45,4.51,36.17,36.17,0,0,1,1.59,4.85,45.2,45.2,0,0,1,1.38,10.13l-2.84-.08a42.35,42.35,0,0,0-.44-9.66,34.51,34.51,0,0,0-1.09-4.73,20.27,20.27,0,0,0-1.9-4.43Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedestriancrossingRafiki);
export default __webpack_public_path__ + "static/media/Pedestriancrossing-rafiki.aa6ebddaebd2e601b3fbdc93b36e72e3.svg";
export { ForwardRef as ReactComponent };